import React from 'react';

import styles from './TeamLead.module.scss';
import { Checkbox } from '@navi/web-ui/lib/primitives';
import { enumMapping, ISelectedFilters } from './interface';
import { getSanitizedEnumValue } from '@cp/src/utils/commonUtils';

interface ITeamLeadFilterCheckboxProps {
  option: string;
  selectedFilter: string;
  isArray: boolean;
  type: string;
  handleSelectedFilter: (selectedFilter: string, option: string) => void;
  selectedOptions: any;
  selectedFilters: ISelectedFilters;
}

const TeamLeadFilterCheckbox: React.FC<ITeamLeadFilterCheckboxProps> = props => {
  const {
    option,
    selectedFilter,
    isArray,
    type,
    handleSelectedFilter,
    selectedOptions,
    selectedFilters
  } = props;
  const dataDisplayMapping = enumMapping[selectedFilter as keyof typeof enumMapping];
  const label = isArray
    ? getSanitizedEnumValue(dataDisplayMapping, option)
    : selectedOptions[option as keyof typeof selectedOptions] + '';

  return (
    <div key={`${option}_${selectedFilter}_${type}`} className={styles.option}>
      <Checkbox
        onChange={e => handleSelectedFilter(selectedFilter, option)}
        title={label}
        defaultChecked={
          selectedFilters?.[selectedFilter as keyof typeof selectedFilters]?.[option] ?? false
        }
        className={styles.checkboxOuterWrapperClass}
      />
    </div>
  );
};

export default TeamLeadFilterCheckbox;
